import PerfectScrollbar from 'perfect-scrollbar';

class Select {
  constructor(el) {
    this.$el = $(el);
    this.$select = this.$el.find('select');
    this.$$options = this.$select.find('option');
    this.$activeOption = null;
    this.$btn = null;
    this.$optionsList = null;
    this.$optionsListInner = null;
    this.$fakeOptions = null;
    this.scrollbar = null;
    this.isOpen = false;
  }

  init() {
    this.defineActiveOption();
    this.buildMarkup();
    this.setEventListeners();
  }


  buildMarkup() {
    let html = `
    <button type="button" class="select__btn">${this.$activeOption.text()}</button>
      <div class="select__list">
      <div class="select__list-inner">
    `;

    this.$$options.each((i, option) => {
      html += `
        <button
          type="button"
          class="select__option"
          data-value="${$(option).val()}"
        >${$(option).text()}</button>
      `;
    });

    html +=  `
        </div>
      </div>
    <div class="select__arrow">
      <svg class="icon icon-chevron">
        <use xlink:href="img/sprite.svg#icon-chevron"></use>
      </svg>
    </div>
    `;

    this.$el.append(html);
    this.$btn = this.$el.find('.select__btn');
    this.$optionsList = this.$el.find('.select__list');
    this.$fakeOptions = this.$el.find('.select__option');
    this.$optionsListInner = this.$el.find('.select__list-inner');

    this.scrollbar = new PerfectScrollbar(this.$optionsListInner[0], {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20
    });

    this.$optionsList.hide();
  }


  setEventListeners() {
    this.$btn.on('click', () => this.toggle());

    $(document).on('click', event => {
      if (!$(event.target).closest(this.$el[0]).length) this.close();
    });

    this.$fakeOptions.each((i, option) => {
      $(option).on('click', event => {
        event.preventDefault();
        this.selectOption($(option).data('value'), $(option).text());
      });
    });
  }

  selectOption(value, text) {
    this.$$options.each((i, el) => {
      if ($(el).val() === value) {
        $(el).prop('selected', true);
      } else {
        $(el).prop('selected', false);
      }
    });
    this.$btn.text(text);
    this.close();
    this.$select.trigger('change');
  }

  open() {
    this.$el.addClass('is-open');

    this.$optionsList.slideDown(() => {
      this.scrollbar.update();
      this.$optionsListInner.scrollTop(0);
    });
    this.isOpen = true;
  }

  close() {

    this.$optionsList.slideUp(() => {
      this.$el.removeClass('is-open');
    });
    this.isOpen = false;
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }


  defineActiveOption() {
    let activeOption = this.$$options.filter((i, el) => {
      return $(el).val() === this.$select.val();
    }).first();

    if (!activeOption) activeOption = this.$$options.first();

    this.$activeOption = $(activeOption);
  }


  static initAll() {
    $('.js-select-field').each((i, el) => {
      const select = new this(el);
      select.init();
    });
  }
};

export default Select;
